import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { waLink } from "@/lib/store";

export function WhatsAppNotifyButton({ order, template, onNotified, testId = "btn-whatsapp-notify", compact = false, kind = "notify", basePath = "/admin" }) {
  const isRemind = kind === "remind";
  const handleClick = async () => {
    try {
      const { data } = await api.post(`${basePath}/orders/${order.id}/${isRemind ? "reminded" : "notified"}`);
      onNotified?.(data);
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  return (
    <a href={waLink(order, template)} target="_blank" rel="noopener noreferrer" onClick={handleClick} data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] font-bold text-white transition-colors hover:bg-[#1ebe5a] ${compact ? "h-9 px-4 text-xs" : "h-11 px-5 text-sm"}`}>
      {isRemind ? "Lembrar cliente" : order.notified_at ? "Avisar de novo" : "Avisar cliente no WhatsApp"}
    </a>
  );
}
